import Overlay from "../ux/Overlay";
import Navbar from "./Navbar";

const Header = () => {
  return (
    <Overlay classes={"bg-intro bg-cover h-[20rem] notebook:h-[25rem] desktop:h-[30rem] full:h-[35rem] py-[2rem] "}>
      <Navbar />

      <div className="pt-[3rem]  ">
        <h1 className="text-white font-bold text-[3rem] notebook:text-[4rem]  desktop:text-[5rem] full:text-[6rem] text-center">
          start your business in USA
        </h1>
        <h2 className="text-white text-[.9rem] notebook:text-[1.2rem] full:text-[1.5rem] mx-auto text-center w-[70%] notebook:w-[50%] desktop:w-[30%] font-light ">
          schedule a free consultation and explore your possibilities
        </h2>
        <div className="border-2 border-white mx-auto text-white text-center w-[30%] notebook:w-[15%] my-[1.5rem] full:my-[2rem] font-bold text-[.9rem] notebook:text-[1.2rem] full:text-[1.5rem] p-[.5rem] hover:bg-white hover:text-gray-600 duration-300">
          <a href="https://wa.me/15618976749"> contact us</a>
        </div>
      </div>
    </Overlay>
  );
};

export default Header;
